var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f3503a0a419a79aac3d8d5169c9d80da.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    